// EOY giving banners
(function () {
    function hideBanner(className, daysToHide) {
        daysToHide = daysToHide || 365;
        if (className) {
            window.createCookie('x' + className, 'true', daysToHide);
            $('.' + className).hide();
        }
    }

    function isBannerDismissed(className) {
        return !!readCookie('x' + className);
    }

    function showOrHideEOYBanners() {
        if (!isBannerDismissed('js-tip-top-donor-banner') && !isBannerDismissed('js-top-donor-banner') && !isBannerDismissed('js-reg-donor-banner')) {
            showDonorMessaging();
        }
    }

    function showDonorMessaging() {
        if (readCookie('v') === 'donor') {
            if (window.isTipTopDonor()) {
                $('.js-tip-top-donor-banner').show();
            } else if (window.isVIPDonor()) {
                $('.js-top-donor-banner').show();
            } else {
                $('.js-reg-donor-banner').show();
            }
        }
    }

    $('.js-tip-top-donor-banner .js-hide-banner').on('click', function () {
        hideBanner('js-tip-top-donor-banner', 16);
    });
    $('.js-top-donor-banner .js-hide-banner').on('click', function () {
        hideBanner('js-top-donor-banner', 16);
    });
    $('.js-reg-donor-banner .js-hide-banner').on('click', function () {
        hideBanner('js-reg-donor-banner', 7);
    });

    document.addEventListener('DOMContentLoaded', function (event) {
        showOrHideEOYBanners();

        $(window).on('signinTriggered signoutTriggered', function () {
            showOrHideEOYBanners();
        });

        if (pageName === 'Checkout (View)') {
            $('#cart-banner').removeClass('on');
        }
    });
})();
